/**
 * Add target="_blank" attribute to all external links on the page.
 */
const externalLinks = () =>
  document.querySelectorAll( 'a' ).forEach( ( link: HTMLAnchorElement ) =>
    link.target = ( link.hostname !== window.location.hostname || link.href.substring( link.href.length - 4 ) === '.pdf' ) ? '_blank' : '_self' )

export default externalLinks
